export default "/images/3.png?74dbc6f2d19d71de4e83d520bbe1b6eb";